import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const SplošniPogoji = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-atren-gray">Splošni pogoji poslovanja</h1>
        
        <div className="prose prose-lg max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">1. Splošne določbe</h2>
            <p>
              Ti splošni pogoji poslovanja (v nadaljevanju: »pogoji«) urejajo pravna razmerja 
              med ATREN INVEST d.o.o. (v nadaljevanju: »podjetje«) in uporabniki storitev 
              (v nadaljevanju: »naročnik«).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">2. Podatki o podjetju</h2>
            <p>
              ATREN INVEST d.o.o.<br/>
              Naslov: Partizanska cesta 71d<br/>
              Matična številka: 6851681000<br/>
              Davčna številka: si29003016<br/>
              E-pošta: info@atren.eu
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">3. Storitve</h2>
            <p>Podjetje zagotavlja naslednje storitve:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Razvoj nepremičnin</li>
              <li>Investicijsko in operativno vodenje projektov</li>
              <li>Izvajanje gradbenih del</li>
              <li>Svetovanje na področju nepremičnin</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">4. Sklenitev pogodbe</h2>
            <p>
              Pogodba se šteje za sklenjeno, ko naročnik pošlje povpraševanje preko kontaktne forme 
              ali elektronske pošte in podjetje potrdi sprejem naročila. Vse podrobnosti se uredijo 
              v ločeni pogodbi.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">5. Cene in plačilni pogoji</h2>
            <p>
              Cene storitev so določene individualno glede na obseg in zahtevnost projekta. 
              Plačilni pogoji se dogovorijo v pogodbi. Vse cene so navedene brez DDV, 
              razen če ni izrecno drugače določeno.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">6. Obveznosti strank</h2>
            <p>Naročnik se obvezuje:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Zagotoviti točne in popolne informacije</li>
              <li>Plačati storitve v dogovorjenih rokih</li>
              <li>Sodelovati pri izvajanju storitev</li>
              <li>Spoštovati navodila podjetja</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">7. Omejitev odgovornosti</h2>
            <p>
              Podjetje ni odgovorno za posredne škode, izgubljeni dobiček ali druge posledične škode, 
              ki bi lahko nastale zaradi uporabe storitev. Odgovornost je omejena na višino 
              pogodbene vrednosti.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">8. Varstvo intelektualne lastnine</h2>
            <p>
              Vsa avtorska dela, načrti, dokumentacija in druga intelektualna lastnina, 
              ki nastane pri izvajanju storitev, ostane last podjetja, razen če ni 
              v pogodbi drugače določeno.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">9. Reševanje sporov</h2>
            <p>
              Za reševanje vseh sporov je pristojno slovensko sodišče. Uporablja se 
              slovensko pravo. Stranki se zavezujeta, da bosta spore poskušali rešiti 
              sporazumno.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-atren-gray">10. Končne določbe</h2>
            <p>
              Ti pogoji veljajo od objave na spletni strani. Podjetje si pridržuje pravico 
              do sprememb pogojev, o katerih bo obvestilo uporabnike.
            </p>
            <p className="text-sm text-gray-500 mt-4">
              Veljavni od: {new Date().toLocaleDateString('sl-SI')}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SplošniPogoji;